var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-items',_vm._l((_vm.isNotAuthenticatedLargeMenu),function(item,index){return _c('v-btn',{key:index,staticClass:"fetch",attrs:{"text":"","to":item.link}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }